import {
  AccountingSystemForCalculatingFinancialStatistics,
  MeetingAdminResponse,
  ApprovalStatus,
  TadpoleToTutorTransactionResponse,
  TadpoleToTutorTransactionType,
} from "client/openapi";
import "./TransactionSettings.css"; // Add some nice styles for the dropdowns

function TransactionSettings({
  accountingSystem,
  setAccountingSystem,
  setTransactions,
  transactionTypeFilter,
  setTransactionTypeFilter,
  adminApprovalFilter,
  setAdminApprovalFilter,
}: {
  accountingSystem: AccountingSystemForCalculatingFinancialStatistics;
  setAccountingSystem: (
    accountingSystem: AccountingSystemForCalculatingFinancialStatistics
  ) => void;
  setTransactions: (
    transactions: TadpoleToTutorTransactionResponse[] | MeetingAdminResponse[]
  ) => void;
  transactionTypeFilter: TadpoleToTutorTransactionType | "all";
  setTransactionTypeFilter: (
    value: TadpoleToTutorTransactionType | "all"
  ) => void;
  adminApprovalFilter: ApprovalStatus | "all";
  setAdminApprovalFilter: (value: ApprovalStatus | "all") => void;
}) {
  return (
    <div className="transaction-settings-container">
      <div className="flex items-center mx-4">
        <div className="toggle-container">
          <button
            className={`toggle-button ${
              accountingSystem ===
              AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS
                ? "active"
                : ""
            }`}
            onClick={() => {
              setAccountingSystem(
                AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS
              );
              setTransactions([]);
            }}
          >
            Transactions
          </button>
          <button
            className={`toggle-button ${
              accountingSystem ===
              AccountingSystemForCalculatingFinancialStatistics.MEETINGS
                ? "active"
                : ""
            }`}
            onClick={() => {
              setAccountingSystem(
                AccountingSystemForCalculatingFinancialStatistics.MEETINGS
              );
              setTransactions([]);
            }}
          >
            Meetings
          </button>
        </div>

        {/* Transaction type filter - now inline */}
        {accountingSystem ===
          AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS && (
          <div className="ml-4 flex items-center">
            <label className="mr-2 font-medium">Type:</label>
            <select
              className="rounded-lg py-1 pl-2 pr-8 border border-gray-300 text-sm w-50"
              value={transactionTypeFilter}
              onChange={(e) =>
                setTransactionTypeFilter(
                  e.target.value as TadpoleToTutorTransactionType | "all"
                )
              }
            >
              <option value={"all"}>All Transactions</option>
              <option
                value={
                  TadpoleToTutorTransactionType.AUTOMATIC_PAYMENT_FOR_A_GROUP_OF_MEETINGS
                }
              >
                Automatic Payroll Payment
              </option>
              <option
                value={TadpoleToTutorTransactionType.MEMBER_OF_PAYMENT_GROUP}
              >
                Direct Payroll Payment, queued to be sent to tutor
              </option>
            </select>
          </div>
        )}

        {/* Admin approval filter - now inline */}
        {accountingSystem ===
          AccountingSystemForCalculatingFinancialStatistics.MEETINGS && (
          <div className="ml-4 flex items-center">
            <label className="mr-2 font-medium">Admin Approval Status:</label>
            <select
              className="rounded-lg py-1 px-2 border border-gray-300 text-sm w-40"
              value={adminApprovalFilter}
              onChange={(e) =>
                setAdminApprovalFilter(e.target.value as ApprovalStatus | "all")
              }
            >
              <option value={"all"}>All Meetings</option>
              <option value={ApprovalStatus.APPROVED}>Approved</option>
              <option value={ApprovalStatus.DENIED}>Denied</option>
              <option value={ApprovalStatus.PENDING}>Pending</option>
            </select>
          </div>
        )}
      </div>
    </div>
  );
}

export default TransactionSettings;
